import React from "react";
import PrimaryButton from "./PrimaryButton";

/**
 * Action buttons for parts (primary and remove)
 */
const PartActionButtons = ({
  onReplaceClick,
  onRemoveClick,
  primaryLabel = "Replace Item",
}) => {
  return (
    <div style={{ display: "flex", gap: "16px", marginTop: "15px" }}>
      <PrimaryButton
        onClick={onReplaceClick}
        variant="primary"
        width="150px"
        height="30px"
      >
        {primaryLabel}
      </PrimaryButton>

      <PrimaryButton
        onClick={onRemoveClick}
        variant="danger"
        width="150px"
        height="30px"
      >
        Remove Item
      </PrimaryButton>
    </div>
  );
};

export default PartActionButtons;
